import { render, staticRenderFns } from "./OtherFormatIcon.vue?vue&type=template&id=3a3c7d97&scoped=true"
import script from "./OtherFormatIcon.vue?vue&type=script&lang=js"
export * from "./OtherFormatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c7d97",
  null
  
)

export default component.exports